import { render, staticRenderFns } from "./EventPromo.vue?vue&type=template&id=42ad1d5b&"
import script from "./EventPromo.vue?vue&type=script&lang=js&"
export * from "./EventPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports